import React from 'react';
import { Routes } from 'react-router-dom';

import { publicRouter } from '../index';
import ShowRouter from './ShowRouter';

const PublicPage: React.FC = () => {
  const route = ShowRouter({ routers: publicRouter });
  return <Routes>{route.views}</Routes>;
};
export default PublicPage;
